import { atom } from 'jotai';

import type { HardwareMicDevice } from '../../contracts/hardware-mic-device.types';

/** Raw hardware-mic snapshot mirrored from the Rust HID reader. */
export const hardwareMicDevicesAtom = atom<HardwareMicDevice[]>([]);

export const hardwareMicDeviceKey = (d: HardwareMicDevice) =>
  `${d.model}:${d.vid}:${d.pid}:${d.serial ?? ''}`;
